import Common from "~/js/common/common";
import store from "~/js/store/store";
import Header from "~/js/common/header";
import Footer from "~/js/common/footer";
import Favorite from "./favorite";
// import HoverImage from "./hoverImage";
import CardName from "./cardName";
import HeaderMenu from "./headerMenu";
import SortStoreItems from "./sortStoreItems";
import NarrowDown from "./narrowDown";
// import SelectLink from "./selectLink";
import Accordion from "./accordion";
import Selector from "./selector";
import Stickypin from "~/js/common/stickypin";
import Tooltip from "~/js/common/tooltip";
import GlobalUsersModal from "../account/modal/globalUsersModal";
export default class Collections {
  constructor() {
    store.subscribe((mutation, state) => {
      if (mutation.type === "beforeScroll") {
      } else if (mutation.type === "init") {
        this.init();
      }
    });

    if (
      navigator.userAgent.indexOf("iPhone") > 0 ||
      navigator.userAgent.indexOf("iPod") > 0 ||
      navigator.userAgent.indexOf("iPad") > 0 ||
      navigator.userAgent.indexOf("Android") > 0 ||
      (/android|ipod|ipad|iphone|macintosh/.test(navigator.userAgent.toLowerCase()) && "ontouchend" in document)
    ) {
      store.dispatch("setIsSP", {
        sta: true
      });
    }

    this.header = new Header();
    this.footer = new Footer();
    this.favorite = new Favorite(document.querySelector("._storeitems"));
    // this.hoverImage = new HoverImage(document.querySelector("._storeitems"));
    this.cardName = new CardName(document.querySelector("._storeitems"));
    this.headerMenu = new HeaderMenu();
    this.sortStoreItems = new SortStoreItems();
    // this.selectLink = new SelectLink();
    this.narrowDown = new NarrowDown(document.querySelector(".c-narrowDown ._brand"),true);
    this.narrowDown = new NarrowDown(document.querySelector(".c-narrowDown ._item"),true);
    this.womens = new Accordion(document.querySelector(".c-narrowDown ._item ._womens"));
    this.mens = new Accordion(document.querySelector(".c-narrowDown ._item ._mens"));
    this.bagsWallets = new Accordion(document.querySelector(".c-narrowDown ._item ._bagsWallets"));
    this.accessoriesMore = new Accordion(document.querySelector(".c-narrowDown ._item ._accessoriesMore"));
    this.selector = new Selector();
    this.stickyPin = new Stickypin();
    this.tooltip = new Tooltip();
    this.globalUsersModal = new GlobalUsersModal();

    store.dispatch("init");
  }

  init() {
    window.scrollTo(0, 0);
    Common.init();
    Common.setupScrollY();
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new Collections();
});
